import {
  and,
  Categorization,
  Tester,
  UISchemaElement,
  uiTypeIs,
} from '@jsonforms/core';

export const isSingleLevelCategorization: Tester = and(
  uiTypeIs('Categorization'),
  (uischema: UISchemaElement): boolean => {
    const categorization = uischema as Categorization;

    return categorization?.elements?.every(e => e.type === 'Category') ?? false;

  }
);
